import { CompletionRule } from '../enums/completion-rule.enum';
import { ICreateProgramOfferingActionPayload } from '../interfaces/create-program-offering.action.payload.interface';

export class ProgramOfferingCommand {
    name: string;
    category: {
        id: number;
    };
    section: boolean;
    self_paced: boolean;
    completion_rule: CompletionRule;
    tags: { id: string }[];
    managers: { id: string }[];

    constructor(tempTap: ICreateProgramOfferingActionPayload) {
        this.name = tempTap.name;
        this.category = { id: Number(tempTap.category.id) };
        this.section = tempTap.section;
        this.self_paced = tempTap.selfPaced;
        this.completion_rule = tempTap.completion_rule;
        this.tags = tempTap.tags.map((tag) => ({ id: tag.id }));
        this.managers = tempTap.managers.length ? tempTap.managers.map((tag) => ({ id: tag.id })) : null;
    }
}
